// src/redux/content/ContentSaga.js
import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchContentRequest,
  fetchContentSuccess,
  fetchContentFailure,
  saveContentRequest,
  saveContentSuccess,
  saveContentFailure,
} from "./ContentSlice";
import { toast } from "react-toastify";

function* fetchContentSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/content/getContentFor`,
        action.payload
      )
    );

    const resData = response.data;
    console.log("resData", resData);  // Should be { data: "<p>dhdhhj</p>" }

    // Even if there's no `.success`, you can handle it safely
    if (resData?.data) {
      yield put(fetchContentSuccess(resData)); // OR resData.data
    } else {
       yield put(fetchContentSuccess({data: ""}));
      yield put(fetchContentFailure("No content found"));
    }
  } catch (error) {
    yield put(fetchContentFailure(error.message));
  }
}


function* saveContentSaga(action) {
  try {
    const response = yield call(() =>
      axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/content/saveContentFor`,
        action.payload,
      )
    );

    const resData = response.data;

    if (resData.data === true) {
      yield put(saveContentSuccess());
      toast.success("Content saved successfully!");
    } else {
      yield put(saveContentFailure("Failed to save content"));
    }
  } catch (error) {
    yield put(saveContentFailure(error.message));
  }
}

export function* watchContentSaga() {
  yield takeLatest(fetchContentRequest.type, fetchContentSaga);
  yield takeLatest(saveContentRequest.type, saveContentSaga);
}
